import { LOGIN_AUTH } from './types';
import axios from 'axios';
import { errorHandler } from './error/errorHandler.action'
import { Url } from './constantUrl'
import { notify } from '../services/notification';

const API_URL = process.env.REACT_APP_API_URL

export const postlogin = (params = {}) => dispatch => {
    const url = API_URL + Url.SIGNINWITH_EMAIL
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.url = url
    return axios(options).then(resp => {
        if (resp.status === 200 || resp.status === 201) {
            dispatch({ type: LOGIN_AUTH, payload: resp })
            return resp
        } else {
            return null
        }
    }).catch(errors => {
        if (errors?.response?.status === 400) {
        notify.error(errors.response.data.message || errors.response.data.error)
            return errors.response
           }
    })
}

// Generate Email OTP
export const generateEmailOtp = (params) => dispatch => {
    const url = API_URL + Url.GENERATE_EMAILOTP;

    return axios({
        method: 'POST',
        url: url,
        data: params   // ✅ now accepts email + password
    })
    .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
            return resp;
        }
        return null;
    })
    .catch(error => {
        return error?.response;
    });
};


// Verify Email OTP
export const verifyEmailOtp = (params) => dispatch => {
    const url = API_URL + Url.VERIFY_EMAILOTP;

    return axios({
        method: 'POST',
        url: url,
        data: params
    })
    .then(resp => {
        if (resp.status === 200 || resp.status === 201) {
            return resp;
        }
        return null;
    })
    .catch(error => {
        return error?.response;
    });
};
